import "./styles.scss";
import { useState, useEffect, useRef } from "react";
import Checkbox from "@mui/material/Checkbox";
import clsx from "clsx";

import { useSelector } from "react-redux";
import { useFixtures } from "../../../hooks/useFixtures";

import { Button } from "../button";
import closeImg from "../../../assets/close.webp";
import doddles from "../../../assets/doddles.webp";

import { formatToMexicoUTC, getDayInMexico } from "../../../utils";

const initStyle = {
  color: "white",
  "&.Mui-checked": {
    color: "white",
  },
};

const winnerStyle = {
  color: "rgb(63,173, 40)",
  "&.Mui-checked": {
    color: "rgb(63,173, 40)",
  },
};

const looserStyle = {
  color: "red",
  "&.Mui-checked": {
    color: "red",
  },
};

const AVAILABLE = "AVAILABLE";
const NOT_AVAILABLE = "NOT_AVAILABLE";

const StatusModal = ({ poolId, match, status, onClose }) => {
  console.log("match", match);
  console.log("status", status);
  const [selectedStatus, setSelectedStatus] = useState(status);

  const { updateFixtureStatus } = useFixtures();

  const onUpdate = () => {
    updateFixtureStatus(poolId, match.id, selectedStatus);
    // console.log("Actualizar status del partido", {
    //   matchId: match.id,
    //   status: selectedStatus,
    //   poolId: poolId,
    // });
    onClose();
  };

  return (
    <div className='top-0 flex justify-center absolute w-[100vw] h-[100dvh] z-50 bg-[rgba(6,20,37,0.9)]'>
      <div
        className='absolute w-[70vw] h-[35vh] z-10 repeat opacity-[0.03] rounded-2xl mt-8'
        style={{ backgroundImage: `url(${doddles})` }}></div>
      <div className='flex flex-col items-center w-[70vw] h-[35vh] bg-[rgb(23,43,69)] rounded-2xl p-5 mt-8'>
        <div className='w-full flex justify-end z-30'>
          <img
            src={closeImg}
            className='z-30'
            alt='close'
            width={14}
            height={14}
            onClick={onClose}
          />
        </div>
        <div className='flex w-full justify-around mt-6 z-30 w-[100%]'>
          <div className='w-[40%] flex flex-col items-center'>
            <img
              src={match.local.logo}
              alt={match.local.name}
              className='w-6 h-6'
            />
            <span className='text-[14px] text-white'>{match.local.name}</span>
          </div>
          <div className='flex flex-col items-center justify-center'>
            <span className='text-[14px] text-white'>VS</span>
          </div>

          <div className='w-[40%] flex flex-col items-center'>
            <img
              src={match.away.logo}
              alt={match.away.name}
              className='w-6 h-6'
            />
            <span className='text-[14px] text-white'>{match.away.name}</span>
          </div>
        </div>
        <div className='flex flex-col w-full z-30 mt-10'>
          <div className='flex items-center'>
            <Checkbox
              sx={initStyle}
              checked={selectedStatus === AVAILABLE}
              onChange={() => setSelectedStatus(AVAILABLE)}
            />
            <span className='text-[14px] text-white'>Disponible</span>
          </div>
          <div className='flex items-center'>
            <Checkbox
              sx={initStyle}
              checked={selectedStatus === NOT_AVAILABLE}
              onChange={() => setSelectedStatus(NOT_AVAILABLE)}
            />
            <span className='text-[14px] text-white'>No disponible</span>
          </div>
        </div>

        <div className='flex flex-1 items-end z-30'>
          <Button label='Actualizar' onClick={onUpdate} />
        </div>
      </div>
    </div>
  );
};

export const PoolResults = ({
  match,
  index,
  onUpdate,
  clear = false,
  disable = false,
  result,
  started,
  poolId,
}) => {
  const [localTeam, setLocalTeam] = useState(false);
  const [visitTeam, setVisitTeam] = useState(false);
  const [tie, setTie] = useState(false);
  const [style, setStyle] = useState(initStyle);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const longPressTimer = useRef(null);

  const matchStatus = match.status || AVAILABLE;

  const user = useSelector((state) => state.user);

  const handlePressStart = () => {
    if (!user.admin || !started) return;
    longPressTimer.current = setTimeout(() => {
      setIsStatusModalOpen(true);
    }, 500);
  };

  const handlePressEnd = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  useEffect(() => {
    if (clear) {
      setLocalTeam(false);
      setVisitTeam(false);
      setTie(false);
      return;
    }

    if (match.result === "L") {
      return setLocalTeam(true);
    }
    if (match.result === "V") {
      return setVisitTeam(true);
    }
    if (match.result === "T") {
      return setTie(true);
    }
  }, [match, clear]);

  useEffect(() => {
    if (result === null || result === undefined) setStyle(initStyle);
    else if (result) setStyle(winnerStyle);
    else setStyle(looserStyle);
  }, [result]);

  const selectLocal = () => {
    setLocalTeam(true);
    setVisitTeam(false);
    setTie(false);
    onUpdate({ index, result: "L" });
  };
  const selectVisit = () => {
    setLocalTeam(false);
    setVisitTeam(true);
    setTie(false);
    onUpdate({ index, result: "V" });
  };
  const selectTie = () => {
    setLocalTeam(false);
    setVisitTeam(false);
    setTie(true);
    onUpdate({ index, result: "T" });
  };

  return (
    <div
      className='flex w-full mt-2 flex-col items-center'
      onMouseDown={handlePressStart}
      onMouseUp={handlePressEnd}
      onMouseLeave={handlePressEnd}
      onTouchStart={handlePressStart}
      onTouchEnd={handlePressEnd}
      onTouchMove={handlePressEnd}
      onContextMenu={(e) => started && e.preventDefault()}>
      <section className='flex w-full justify-center items-center'>
        <Checkbox
          size='small'
          disabled={disable}
          sx={style}
          checked={localTeam}
          onChange={selectLocal}
        />
        <section className='flex flex-col flex-1 items-center'>
          <img
            src={match.local.logo}
            alt={match.local.name}
            width='22'
            height='22'
            className={clsx({ "opacity-50": visitTeam })}
          />
          <span
            className={clsx("text-[11px] mt-[2px]", {
              "line-through": result === false || matchStatus !== AVAILABLE,
              "opacity-50": visitTeam || matchStatus !== AVAILABLE,
            })}>
            {match.local.name}
          </span>
        </section>
        <Checkbox
          size='small'
          disabled={disable}
          checked={tie}
          sx={style}
          onChange={selectTie}
        />
        <section className='flex flex-col flex-1 items-center'>
          <img
            src={match.away.logo}
            alt={match.away.name}
            width='22'
            height='22'
            className={clsx({ "opacity-50": localTeam })}
          />
          <span
            className={clsx("text-[11px] mt-[2px]", {
              "line-through": result === false || matchStatus !== AVAILABLE,
              "opacity-50": localTeam || matchStatus !== AVAILABLE,
            })}>
            {match.away.name}
          </span>
        </section>
        <Checkbox
          size='small'
          disabled={disable}
          checked={visitTeam}
          sx={style}
          onChange={selectVisit}
        />
      </section>
      <span
        className={clsx("text-[10px] my-1", {
          "line-through": matchStatus !== AVAILABLE,
          "opacity-50": matchStatus !== AVAILABLE,
        })}>
        {getDayInMexico(match.time)} {formatToMexicoUTC(match.time)}
      </span>
      <div className='w-full h-[1px] bg-white/20 mt-3' />
      {isStatusModalOpen && (
        <StatusModal
          poolId={poolId}
          match={match}
          status={matchStatus}
          onClose={() => setIsStatusModalOpen(false)}
        />
      )}
    </div>
  );
};
